import { Button } from "antd";
import { FC } from "react";
import GoogleSVG from "../../../assets/auth/GoogleSVG";
import AppleSVG from "../../../assets/auth/AppleSVG";
import { messageSVG } from "../../../assets/SVGs/SVGs";
import { Link, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

interface AuthProps {}

const Auth: FC<AuthProps> = ({}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <div className="shadow p-6 space-y-4 rounded-lg ">
      <div className="space-y-4">
        <h4 className="text-salon-primary text-xl ">
          {intl.formatMessage({ id: "joinLookfindr" })}
        </h4>
        <p className="text-color-sec-title">
          {intl.formatMessage({ id: "completeToJoinLookfindr" })}
        </p>
      </div>
      <div>
        <div className="max-w-[350px] space-y-3">
          <div className=" space-y-3 rounded-lg py-2">
            <Button
              type="default"
              htmlType="button"
              block
              className="flex justify-start items-center px-8"
            >
              <GoogleSVG />
              <span className="mx-1">
                {intl.formatMessage({ id: "continueWithGoogle" })}
              </span>
            </Button>
            <Button
              type="default"
              htmlType="button"
              block
              className="flex justify-start items-center px-8"
            >
              <AppleSVG />
              <span className="mx-1">
                {intl.formatMessage({ id: "continueWithApple" })}
              </span>
            </Button>
          </div>
          <div style={{ borderBottom: "1px solid #CFCFE2" }}></div>
          <div>
            <Button
              type="primary"
              htmlType="button"
              block
              className="flex justify-start items-center px-8"
              onClick={() => navigate("register")}
            >
              {messageSVG}
              <span className="mx-1">
                {intl.formatMessage({ id: "joinWithMobileNumber" })}
              </span>
            </Button>
          </div>
          <div>
            <p className="text-color-sec-title">
              {intl.formatMessage({ id: "haveAccount" })}{" "}
              <Link to="login" className="text-color-primary ">
                {intl.formatMessage({ id: "login" })}
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
